import { graphql, readInlineData } from "react-relay";

import { section as sectionData } from "shared/data";

import type { helpersCheckIsStyleArticle$key } from "scmp-app/queries/__generated__/helpersCheckIsStyleArticle.graphql";

export const checkIsStyleArticle = (reference: helpersCheckIsStyleArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersCheckIsStyleArticle on Content @inline {
        sectionsV2 {
          value {
            ... on Section {
              entityId
            }
            ... on VideoSection {
              entityId
            }
          }
        }
      }
    `,
    reference,
  );

  const [firstSectionEntityId, secondSectionEntityId] =
    article?.sectionsV2?.flatMap(section => section?.value?.map(value => value?.entityId)) ?? [];

  return (
    firstSectionEntityId === sectionData.magazine.entityId &&
    secondSectionEntityId === sectionData.style.entityId
  );
};
